import type { TeamFilters } from '../../../../application/hooks/team/useTeamQueries';
import { useTranslation } from '../../../../application/hooks/useTranslation';

export interface TeamFilterBarProps {
  filters: TeamFilters;
  onChange: (next: TeamFilters) => void;
  showTierPills: boolean;
}

const TIERS: Array<[TeamFilters['tier'], string]> = [
  ['ALL', 'team.tierAll'],
  ['L1', 'team.tierL1'],
  ['L2', 'team.tierL2'],
  ['L3+', 'team.tierL3'],
];

export function TeamFilterBar({ filters, onChange, showTierPills }: TeamFilterBarProps) {
  const { t } = useTranslation();
  return (
    <div className="tm-filters">
      {showTierPills && (
        <div className="tm-pills" role="group" aria-label="Tier" data-testid="team-filter-tier">
          {TIERS.map(([value, key]) => (
            <button
              key={value}
              type="button"
              className={`tm-pill${filters.tier === value ? ' is-active' : ''}`}
              aria-pressed={filters.tier === value}
              onClick={() => onChange({ ...filters, tier: value })}
            >
              {t(key)}
            </button>
          ))}
        </div>
      )}
      <div className="tm-selects">
        <label className="tm-select">
          <span className="tm-sr-only">{t('team.statusFilter')}</span>
          <select
            value={filters.status}
            onChange={(e) => onChange({ ...filters, status: e.target.value as TeamFilters['status'] })}
            data-testid="team-filter-status"
          >
            <option value="ALL">{t('team.statusAll')}</option>
            <option value="OVERDUE">{t('team.statusOverdue')}</option>
            <option value="INACTIVE">{t('team.statusInactive')}</option>
            <option value="CLOSED">{t('team.statusClosed')}</option>
          </select>
        </label>
        <label className="tm-select">
          <span className="tm-sr-only">{t('team.sortLabel')}</span>
          <select
            value={filters.sort}
            onChange={(e) => onChange({ ...filters, sort: e.target.value as TeamFilters['sort'] })}
            data-testid="team-sort"
          >
            <option value="overdue">{t('team.sortOverdue')}</option>
            <option value="name">{t('team.sortName')}</option>
            <option value="joined">{t('team.sortJoined')}</option>
            <option value="progress">{t('team.sortProgress')}</option>
          </select>
        </label>
      </div>
    </div>
  );
}
